import { createReducer } from "../../../_common/common";
import { SET_CERTIFICATE_TYPES, SET_PURCHASED_CERTIFICATES, SET_PRESTA_CERTIFICATES } from "../actions/constants";

const initialState = {
    types: null, // Para almacenar los tipos de certificados
    prestaCertificates: null
}
export const certificates = createReducer(initialState, {
    [SET_CERTIFICATE_TYPES]: (state, payload) => ({
        ...state,
        types: payload
    }),
    [SET_PURCHASED_CERTIFICATES]: (state, payload) => ({
        ...state,
        purchasedCertificates: {
            ...state.purchasedCertificates,
            ...payload
        }
    }),
    [SET_PRESTA_CERTIFICATES]: (state, { academicProgramId, certificates }) => {
        const prev = state.prestaCertificates?.[academicProgramId] || [];
        const merged = [...prev, ...certificates];
        const unique = Array.from(
            new Map(merged.map(item => [item.id_attribute, item])).values()
        );

        return {
            ...state,
            prestaCertificates: {
                ...state.prestaCertificates,
                [academicProgramId]: unique
            }
        };
    }
});
